module.exports = __webpack_public_path__ + "img/arrow-small-dark.022f9152.svg";